var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/ant/outlined/suggested/close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0116 10L16.1385 3.88867C16.2245 3.78711 16.1522 3.63281 16.0194 3.63281H14.4608C14.369 3.63281 14.2811 3.67383 14.2206 3.74414L9.99204 8.78516L5.76352 3.74414C5.70493 3.67383 5.61704 3.63281 5.52329 3.63281H3.9647C3.83188 3.63281 3.75962 3.78711 3.84555 3.88867L8.97251 10L3.84555 16.1113C3.8263 16.134 3.81395 16.1617 3.80997 16.1911C3.80599 16.2206 3.81054 16.2505 3.82308 16.2775C3.83562 16.3044 3.85564 16.3272 3.88074 16.3431C3.90584 16.359 3.93498 16.3674 3.9647 16.3672H5.52329C5.61509 16.3672 5.70298 16.3262 5.76352 16.2559L9.99204 11.2148L14.2206 16.2559C14.2791 16.3262 14.367 16.3672 14.4608 16.3672H16.0194C16.1522 16.3672 16.2245 16.2129 16.1385 16.1113L11.0116 10Z",
    fill: "#45505A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.7890fc810a064b9c2b37a16dda10dfa6.svg";
export { ForwardRef as ReactComponent };